<div
    id="app"
    class="mobile-authenticated-layout"
    [class.menu-collapsed]="menuCollapsed"
    [class.scrolled-by]="100 | scrolledBy"
    [@routeAnimations]="getRouteAnimationData()"
    [class.notif-opened]="notificationsIsOpened"
    [class.has-unread-notifications]="notificationsHasUnread$ | async">

    <header id="top-bar" layout-top-bar-mobile
            [user]="currentUserAvatar$ | async"
            [userInfos]="userPopoverContent$ | async"
            [currentLanguage]="currentLanguage$ | async"
            [tenantName]="pageOverTitle$ | async"
            [tenantLogo]="pageOverLogo$ | async"
            (selectLanguage)="selectLanguage($event)" (logout)="logout()"
            (action)="handleAction($event)">
    </header>

    <section id="content" scrolledByContainer>
        <main id="main">
            <router-outlet/>
        </main>
    </section>

    <nav
        id="mobile-menu"
        layout-menu-mobile
        (action)="handleAction($event, 'menu')"
        [currentUser]="currentUser$ | async"
        [hasImportHistoryClearanceLevel]="hasImportHistoryClearanceLevel | async"
        [hasManualImportClearanceLevel]="hasManualImportClearanceLevel$ | async"
        [hasTeamFollowUpClearanceLevel]="hasTeamFollowUpClearanceLevel$ | async"
        [hasAdministrationToolsClearanceLevel]="hasAdministrationToolsClearanceLevel$ | async"
        [hasSuperAdministrationClearanceLevel]="hasSuperAdministrationClearanceLevel$ | async"
        [hasReadOnlyAccessToAllSuperDebtorsClearanceLevel]="hasReadOnlyAccessToAllSuperDebtorsClearanceLevel$ | async"
        >
    </nav>

    @if (errors$ | async; as errors) {
        <ngb-alert [class.d-none]="!showErrors || !errors?.length" type="danger" [dismissible]="true" (closed)="showErrors = false">
            @for (e of errors; track e) { {{e?.toString()}} }
        </ngb-alert>
    }
</div>
